
import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ActivityDataModel from "../data-models/Activity.DataModel";

export default function getReferralActivities(referralId: number, abortSignal: AbortSignal): Promise<Array<ActivityDataModel>> {
    return apiGet<Array<ActivityDataModel>>('/referrals/' + referralId + '/activities', abortSignal);
}